import * as React from "react";
import {SvgIcon} from "@mui/material";

export default function IconMaison(props) {
    return (
        <SvgIcon
            {...props}
        >
            <g transform="translate(0.000000,24.000000) scale(0.004687,-0.004687)"
               fill="#000000" stroke="none">
                <path d="M1370 3880 c-709 -497 -1202 -848 -1227 -875 -58 -64 -86 -140 -86
-240 -1 -148 70 -263 201 -327 61 -30 74 -33 162 -33 77 0 104 4 142 22 26 12
483 327 1015 699 533 373 975 678 983 678 8 0 450 -305 983 -678 532 -372 989
-687 1015 -699 38 -18 65 -22 142 -22 88 0 101 3 162 33 131 64 202 179 201
327 0 104 -28 178 -91 245 -29 30 -495 362 -1222 871 -646 451 -1179 823
-1185 825 -5 2 -543 -369 -1195 -826z"/>
                <path d="M1778 3113 l-778 -545 0 -1028 0 -1027 23 -34 c47 -71 33 -69 610
-69 l517 0 0 398 0 398 -54 23 c-75 31 -130 81 -165 153 l-31 61 0 431 c0 430
0 431 24 481 55 119 160 174 444 231 23 5 22 7 -21 53 -85 91 -121 194 -115
334 5 149 60 240 178 296 47 22 68 26 150 26 82 0 103 -4 150 -26 118 -56 173
-147 178 -296 6 -140 -30 -243 -114 -333 -46 -50 -47 -60 -4 -60 46 0 216 -47
272 -75 70 -35 125 -88 154 -150 l24 -50 0 -431 0 -431 -31 -61 c-35 -72 -90
-122 -165 -153 l-54 -23 0 -398 0 -398 518 0 c576 0 562 -2 609 69 l23 34 0
1027 0 1028 -779 546 c-429 300 -781 546 -783 545 -1 0 -353 -246 -780 -546z"/>
                <path d="M2450 3148 c-62 -32 -91 -90 -91 -185 0 -86 6 -114 43 -184 42 -81
77 -104 158 -104 53 0 71 4 95 23 68 53 106 147 106 260 0 144 -64 212 -201
212 -48 0 -78 -6 -110 -22z"/>
                <path d="M2400 2460 c-149 -21 -270 -59 -320 -102 -51 -43 -50 -33 -50 -484
l0 -421 23 -34 c12 -18 38 -44 57 -57 l35 -23 5 376 c5 358 6 377 24 391 28
20 63 17 86 -6 20 -20 20 -33 20 -855 l0 -835 110 0 110 0 0 354 c0 348 4 400
33 418 22 14 64 8 80 -10 15 -17 17 -58 17 -390 l0 -372 105 0 105 0 0 835 c0
822 0 835 20 855 23 23 58 26 86 6 18 -14 19 -33 24 -391 l5 -376 35 23 c19
13 45 39 57 57 l23 34 0 420 c0 406 -1 421 -21 453 -28 45 -121 90 -239 115
-109 22 -332 32 -430 19z"/>
            </g>
        </SvgIcon>
    );
}